import React from 'react'
import strings from 'utils/strings'
import PropTypes from 'prop-types'
import { useSelector } from 'hooks/redux'
import { propOr } from 'ramda'
import { Button, Paragraph } from 'components/patterns'
import { getRelativeOutput } from 'selectors/feature/outputs'
import { Box, InputBox } from './ContextualHelpFeatureOutput.style'

const ContextualHelpFeatureOutput = (props) => {
  const { relatedOutput, onCancelClick, onAddClick } = props

  const outputId = relatedOutput.split('/')[2]
  const outputDetails = useSelector(getRelativeOutput, { outputId })
  const descriptionText = propOr('', 'description', outputDetails)

  return (
    <Box>
      <InputBox>
        <Paragraph size="small" weight="bold">
          {descriptionText}
        </Paragraph>
      </InputBox>
      <Button
        type="secondary"
        onClick={onCancelClick}
        text={strings.no_thanks}
      />
      <Button type="primary" onClick={onAddClick} text={strings.add} />
    </Box>
  )
}

ContextualHelpFeatureOutput.propTypes = {
  relatedOutput: PropTypes.string,
  onCancelClick: PropTypes.func,
  onAddClick: PropTypes.func,
}

export default ContextualHelpFeatureOutput
